import { React } from "react";
import { useTranslation } from "react-i18next";
import BetweenDates from "../../AdvanceSearchTest/components/AdvanceSearchBetweenDates";
import Notes from "../components/Notes";
import { Managers } from "../components/Managers";
import ManagerInterest from "../ManagerInterest";
import BusinessArea from "../components/BusinessArea";
import TechArea from "../components/TechArea";
import BusinessAreaInterest from "../components/BusinessAreaInterest";
import TechAreaInterest from "../components/TechAreaInterest";
import { InactiveManagers } from "../../AdvanceSearchTest/components/InactiveManagers";
import RatingItem from "../components/AdvanceSearchRating";
import Recommended from "../components/Recommended";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { ValidateFields } from "../ValidateFields";
import { Row } from "react-bootstrap";
import JobRole from "../components/JobRole";
import Tags from "../components/Tags";

export function Global({ changeCardStatus, cardStatus }) {
  const { t } = useTranslation();
  const { searchObject, setSearchObject, onChange } = useAdvanceSearchContext();

  function clearGlobal() {
    searchObject.managerInterestId = [];
    searchObject.managerId = undefined;
    searchObject.recommended = undefined;
    searchObject.addNote = undefined;
    searchObject.rating = undefined;
    searchObject.endingDate = undefined;
    searchObject.startingDate = undefined;
    searchObject.businessAreaId = undefined;
    searchObject.techAreaId = undefined;
    searchObject.techRoleId = undefined;
    searchObject.candidateInterestTechRoleId = undefined;
    searchObject.candidateInterestTechAreaId = undefined;
    searchObject.candidateInterestBusinessAreaId = undefined;
    searchObject.businessAreas = [];
    searchObject.candidateBusinessAreas = [];
    searchObject.jobRoles = [];
    searchObject.tags = [];

    setSearchObject({
      ...searchObject
    });
  }

  return (
    <>
      <div className="accordion-item border-accordion">
        <h2
          className="accordion-header margin-accordion"
          id="headingCompetence"
        >
          <button
            className={`accordion-button border-accordion-button ${
              cardStatus ? "" : "collapsed heding-bold"
            }`}
            type="button"
            data-bs-target="#collapseCvs"
            aria-expanded="true"
            aria-controls="collapseCvs"
            onClick={changeCardStatus}
            id="accordionGlobal"
          >
            {`${t("Global")} ${ValidateFields.global(searchObject)}`}
          </button>
        </h2>
        <div
          id="accordionInputs"
          className={`accordion-collapse ${cardStatus ? "" : "collapse"}`}
          aria-labelledby="headingCompetence"
          data-bs-parent="#accordionFlushDocuments"
        >
          <div className="accordion-body table-wrap ">
            <Row>
              <div className="col-md-4">
                <ManagerInterest
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <Recommended
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <JobRole
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <BusinessArea
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-8">
                <TechArea
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <BusinessAreaInterest
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-8">
                <TechAreaInterest
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <Managers
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <InactiveManagers
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <Tags
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <BetweenDates
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
              <div className="col-md-4" style={{ marginTop: "40px" }}>
                <RatingItem
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  o
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-8">
                <Notes searchObject={searchObject} onChange={onChange} t={t} />
              </div>
            </Row>
          </div>
          <div className="text-end button-clear-position">
            <button
              className="app-button btn-second btn-md"
              onClick={clearGlobal}
            >
              {t("Clear Global")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
